import { createRpcMutation } from './factory'

export const useDeleteUserOrganization = createRpcMutation({
   fn: 'delete_user_organization',
   successKey: 'info.user-organization-deleted',
   invalidates: (props) => [['organization', { id: props.p_organization_id }]],
})
